import { useMediaQuery } from "./useMediaQuery";

/**
 * Tailwind's default breakpoint min-widths, in pixels. This storefront doesn't
 * override `screens` (no `theme.screens` in `tailwind.config.js`, and the
 * `@medusajs/ui-preset` leaves them at Tailwind's defaults), so these are the
 * single source of truth for reading in JS the same thresholds the `sm:`/`md:`/
 * `lg:`/`xl:`/`2xl:` utility variants switch on in CSS.
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/**
 * Whether the viewport is at least `breakpoint` wide, using the same min-width
 * semantics as Tailwind's variants: `useBreakpoint("lg")` is `true` exactly
 * when the `lg:` classes are active.
 *
 * For a layout that only needs CSS, prefer a responsive class (`lg:flex-row`) -
 * it needs no JS and no re-render. Reach for this hook when the *behaviour*, not
 * just the styling, has to branch on width: rendering a drawer vs. an inline
 * panel, wiring different handlers, choosing what to mount.
 */
export function useBreakpoint(breakpoint: Breakpoint): boolean {
  return useMediaQuery(`(min-width: ${BREAKPOINTS[breakpoint]}px)`);
}
